module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-19.dd6e0408.png";